import { useSelector } from 'react-redux';

import { IOfferSummaryInfoItemProps } from '../../../../../components/OfferSummaryInfo';
import { offerSelector } from '../../../../../selectors';
import { businessShoppingCenterSelector } from '../../../../../selectors/offerData/offer/businessShoppingCenterSelector';
import { buildingTypes, getStatusType } from '../../../../../utils/offer_helpers';

export interface IUseSummaryInfoBusinessCenterProps {
  businessShoppingCenterName: string;
  summaryInfoItems: IOfferSummaryInfoItemProps[];
}

export const useSummaryInfoBusinessCenterProps = (): IUseSummaryInfoBusinessCenterProps | null => {
  const offer = useSelector(offerSelector);
  const businessShoppingCenter = useSelector(businessShoppingCenterSelector);

  if (!businessShoppingCenter) {
    return null;
  }

  const statusType = getStatusType(offer.building, businessShoppingCenter);

  const summaryInfoItems: IOfferSummaryInfoItemProps[] = [];

  if (businessShoppingCenter.buildYear) {
    summaryInfoItems.push({
      name: 'Год постройки',
      value: businessShoppingCenter.buildYear,
    });
  }

  if (businessShoppingCenter.buildingStatusType && statusType) {
    summaryInfoItems.push({
      name: 'Категория здания',
      value: statusType,
    });
  }

  if (businessShoppingCenter.buildingType) {
    summaryInfoItems.push({
      name: 'Тип здания',
      value: buildingTypes[businessShoppingCenter.buildingType],
    });
  }

  if (businessShoppingCenter.totalArea) {
    summaryInfoItems.push({
      name: 'Общая площадь',
      value: businessShoppingCenter.totalArea,
    });
  }

  if (businessShoppingCenter.ventilationType) {
    summaryInfoItems.push({
      name: 'Вентиляция',
      value: businessShoppingCenter.ventilationType,
    });
  }

  if (businessShoppingCenter.conditioningType) {
    summaryInfoItems.push({
      name: 'Кондиционирование',
      value: businessShoppingCenter.conditioningType,
    });
  }

  if (businessShoppingCenter.heatingType) {
    summaryInfoItems.push({
      name: 'Отопление',
      value: businessShoppingCenter.heatingType,
    });
  }

  if (businessShoppingCenter.extinguishingSystemType) {
    summaryInfoItems.push({
      name: 'Система пожаротушения',
      value: businessShoppingCenter.extinguishingSystemType,
    });
  }

  if (!summaryInfoItems.length) {
    return null;
  }

  return {
    businessShoppingCenterName: businessShoppingCenter.name ?? '',
    summaryInfoItems,
  };
};
